import React, { useMemo, useState } from 'react';
import Modal from './ui/Modal.jsx';

const CreditConversionModal = ({
    type, // 'exam' | 'notes' | 'games'
    folder, // optional for notes/games
    creditsBalance = 0,
    defaultQuestions = 10,
    onConfirm, // ({cost, count, selectedQuestions}) => void
    onClose,
}) => {
    const [count, setCount] = useState(() => {
        if (type === 'exam') return '';
        const n = Array.isArray(folder?.cards) ? folder.cards.length : 0;
        return n || 0;
    });

    const title = type === 'exam' ? 'Use Credits for Exam' : type === 'notes' ? 'Use Credits for Flash Notes' : 'Use Credits for Game';
    const unit = type === 'exam' ? 'questions' : (type === 'notes' ? 'cards' : 'units');
    const hint = type === 'exam' ? '1 credit per question' : (type === 'notes' ? '1 credit per card' : 'Use credits to buy game units');
    const cost = useMemo(() => {
        const n = Number(count || 0);
        if (type === 'exam') return Math.max(0, n); // 1:1 question-to-credit
        if (type === 'notes') return Math.max(0, n); // 1 credit per card
        return Math.max(0, n); // games: cost equals selected units
    }, [count, type]);
    const disabled = !count || cost <= 0 || cost > creditsBalance;

    return (
        <Modal title={title} onClose={onClose} size="md">
            <div className="space-y-3">
                <p className="text-sm text-slate-300">{hint}. Available credits: <span className="text-amber-300 font-semibold">{creditsBalance}</span></p>
                <div className="grid gap-2">
                    <label className="text-xs text-slate-400">{`Number of ${unit}`}</label>
                    <div className="flex items-center gap-2">
                        <input
                            type="number"
                            min={1}
                            value={count}
                            placeholder={type === 'exam' ? 'Number of questions' : `Number of ${unit}`}
                            onChange={(e) => {
                                const v = e.target.value;
                                if (v === '' || v == null) { setCount(''); return; }
                                setCount(Math.max(1, Number(v)));
                            }}
                            className="w-44 rounded-lg bg-slate-800/70 border border-white/10 px-3 py-2 text-sm text-slate-200"
                        />
                    </div>
                    <div className="text-sm text-slate-300">Cost: <span className="text-amber-300 font-semibold">{cost}</span> credit{cost===1?'':'s'}</div>
                </div>
                <div className="pt-2 flex justify-end gap-2">
                    <button type="button" className="inline-flex items-center gap-2 rounded-xl px-4 py-2 text-sm text-slate-200 bg-slate-800/70 hover:bg-slate-800 ring-1 ring-white/10" onClick={onClose}>Cancel</button>
                    <button type="button" disabled={disabled} className={`inline-flex items-center gap-2 rounded-xl px-4 py-2 text-sm ${disabled ? 'bg-slate-700 text-slate-400 cursor-not-allowed' : 'text-white bg-gradient-to-r from-teal-600 to-emerald-600'}`} onClick={() => onConfirm({ cost, count, selectedQuestions: Number(count || 0) })}>Use Credits</button>
                </div>
            </div>
        </Modal>
    );
};

export default CreditConversionModal;


